// @mui
import { Box, Stack, Typography } from "@mui/material";
import { UseFormGetValues } from "react-hook-form";
// styling
import styles from "src/components/UI/Profile/assets/scss/Profile.module.scss";

interface AddressDisplayProps {
  getValues: UseFormGetValues<{
    user_name: any;
    profession: any;
    first_name: any;
    last_name: any;
    email: any;
    bio: any;
    street: any;
    city: any;
    state: any;
    country: any;
    zip_code: any;
  }>;
  }
const AddressDisplay = ({ getValues }: AddressDisplayProps) => {
  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1} alignItems="flex-start" sx={{ p: 0 }}>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Street address
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("street")}
            </Typography>
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              City
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("city")}
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            width: "100%",
          }}
          rowGap={1}
          columnGap={1}
          display="grid"
          gridTemplateColumns="repeat(2, 1fr)"
        >
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              State
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("state")}
            </Typography>
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Country
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("country")}
            </Typography>
          </div>
          <div className={styles.detailsItem}>
            <Typography className={styles.detailsInfoHead} variant="subtitle2">
              Zip code
            </Typography>
            <Typography className={styles.detailsInfo} variant="subtitle2">
              {getValues("zip_code")}
            </Typography>
          </div>
        </Box>
      </Stack>
    </Box>
  );
};

export default AddressDisplay;
